import { getItem, removeItem, setItem } from '.';

const SIGNALR_RECOVERY_KEY = 'signalr-recovery';
const SIGNALR_TAB_ID_KEY = 'signalrTabId';

interface ISignalRRecoveryState {
  owner: string;
  updatedAt: number;
}

export const getSignalRRecoveryState = (): ISignalRRecoveryState | null =>
  getItem(SIGNALR_RECOVERY_KEY);

export const setSignalRRecoveryState = (data: ISignalRRecoveryState): void =>
  setItem(SIGNALR_RECOVERY_KEY, data);

export const deleteSignalRRecoveryState = (): void => removeItem(SIGNALR_RECOVERY_KEY);

export const getSignalRTabId = (): string | null => sessionStorage.getItem(SIGNALR_TAB_ID_KEY);

export const setSignalRTabId = (tabId: string): void => {
  sessionStorage.setItem(SIGNALR_TAB_ID_KEY, tabId);
};
